import { transform } from './transform';
import table from './table';

const name = 'autoArchive';
const path = 'students/changed_program_type_students';

export default {
  table,
  get: {
    name,
    path,
    transform
  },
  changeStatus: {
    method: 'patch',
    path: `students/archive_or_dismiss/:studentId`
  }
};
